import { a as __rest } from '../../_tslib.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import styles from './Card.styles.esm.js';
import { simulateButtonKeyboardBehavior } from '../../testUtils/buttonKeyboardBehavior.esm.js';

const Card = React__default.forwardRef((_a, ref) => {
  var {
      className,
      inverse = false,
      variant = "standard",
      "aria-label": ariaLabel,
      onClick,
      children,
      interactive,
      href
    } = _a,
    props = __rest(_a, ["className", "inverse", "variant", "aria-label", "onClick", "children", "interactive", "href"]);
  const baseClass = styles({
    class: className,
    inverse,
    variant,
    interactive
  });
  const Tag = React__default.useMemo(() => {
    if (!interactive) return "div";
    return href ? "a" : "button";
  }, [href, interactive]);
  const tabIndex = React__default.useMemo(() => {
    if (!interactive) {
      return undefined;
    }
    return 0;
  }, [interactive]);
  return jsx(Tag, Object.assign({
    ref: ref,
    className: baseClass,
    tabIndex: tabIndex,
    "aria-label": interactive ? ariaLabel : undefined,
    onKeyDown: Tag === "button" ? simulateButtonKeyboardBehavior(onClick) : undefined,
    onClick: Tag === "button" ? onClick : undefined,
    href: Tag === "a" ? href : undefined
  }, props, {
    children: children
  }));
});
Card.displayName = "Card";

export { Card };
